import * as React from 'react';
import * as styles from './signed_popup.css';

export interface ISignedPopupProps {
  email: string;
  userEmail: string | null;
  isAuthenticated: boolean | null;
}

export function isEmailEqual(email: string, userEmail: string | null) {
  return userEmail && email.trim().toLowerCase() === userEmail.toLowerCase();
}

export function SignedPopup({ email, userEmail, isAuthenticated }: ISignedPopupProps) {
  return (
    <>
      <div className={styles['success-text']}>
        {isAuthenticated && isEmailEqual(email, userEmail)
          ? 'Мы оповестим вас, когда появятся новые объявления по вашему поиску'
          : 'Активируйте вашу подписку с помощью ссылки из письма, отправленного на адрес'}
      </div>
      <div className={styles['success-email']}>{email}</div>
    </>
  );
}
